import { styled } from 'styled-components';
import { tk } from '@sunwebgroup/ui-components';

const Root = styled.div`
  display: flex;
  flex-direction: column;

  @media ${tk('mq_tablet')} {
    flex-direction: row;
  }

  padding: ${tk('spacing_lg')};
  border: 2px solid #e7e0d7;
  border-radius: ${tk('radius_medium')};
  background-color: #f3f0ed;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin-top: ${tk('spacing_sm')};

  @media ${tk('mq_tablet')} {
    margin-top: 0;
    max-width: 800px;
    margin-right: auto;
    margin-left: ${tk('spacing_md')};
  }
`;

const TitleDescription = styled.div`
  display: flex;
  flex-direction: column;
`;

export default { Root, Content, TitleDescription };
